import { PaymentDetail } from 'types';

const normalizeKeyPart = (value: unknown) => String(value ?? '').trim().toUpperCase();

export default function getPaymentDetailKey(prefix: string, detail: PaymentDetail) {
    const adjustmentIdentityKey = normalizeKeyPart(detail.adjustmentIdentityKey);
    if (adjustmentIdentityKey) {
        return `${normalizeKeyPart(prefix)}_${adjustmentIdentityKey}`;
    }

    return [
        prefix,
        detail.accountId,
        detail.vendorId,
        detail.paymentId,
        detail.paymentIdRef,
        detail.businessUnit,
        detail.voucherId,
        detail.invoiceId,
        detail.customerId,
        detail.customerItemReference,
        detail.adjustmentTypeId,
        detail.marBillingCodeId,
        detail.marDisputeTypeId,
        detail.marBillTypeDescription,
        detail.adjustmentAmount,
    ].map(normalizeKeyPart).join('_');
}
